import { defineComponent as _defineComponent } from 'vue';
import { faCheck, faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { ref, watch } from "vue";
import localize from "@/utils/localization";
import ClickToEdit from "@/components/Collections/common/ClickToEdit.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ListDatasetCollectionElementView',
    props: {
        element: null,
        selected: { type: Boolean },
        hasActions: { type: Boolean },
        notEditable: { type: Boolean }
    },
    emits: ["onRename", "element-is-selected", "element-is-discarded"],
    setup(__props, { emit }) {
        const props = __props;
        const elementName = ref(props.element.name || "...");
        watch(elementName, () => {
            emit("onRename", elementName.value);
        });
        function clickDiscard() {
            emit("element-is-discarded", props.element);
        }
        return { __sfc: true, props, emit, elementName, clickDiscard, faCheck, faMinus, FontAwesomeIcon, localize, ClickToEdit };
    }
});
